exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".control.lang-switch[data-v-7bc6bdc4]{position:relative;display:flex;align-items:center;justify-content:center;color:#fff}.control.lang-switch .separator[data-v-7bc6bdc4]{height:14px;width:1px;background:#fff;display:block;margin:0 10px 0 8px}.control.lang-switch .lang[data-v-7bc6bdc4]{cursor:pointer;opacity:.7}.control.lang-switch .lang.active[data-v-7bc6bdc4],.control.lang-switch .lang[data-v-7bc6bdc4]:hover{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bc6bdc4","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/controls/lang-switch.vue
// module id = 374
// module chunks = 0